import { SharedFields } from "../../configs";
import { ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";

const formulaField: ScreenSectionConfigType = {
  field: "formula",
  label: "common.tables.formula",
  view: "normal",
};

export const formulaScreenConfig = {
  type: "simple" as ScreenType,
  sections: [...SharedFields.name, ...SharedFields.description, formulaField],
};
